// Alineado con StatusBeartrackEnum (microservice-packages-status)
export const packageStatus = {
  0: "Pendiente",
  1: "Recolectado",
  2: "En bodega",
  3: "En ruta",
  30: "En entrega a domicilio",
  4: "Entregado",
  5: "Cancelado",
  6: "Entrega fallida",
  7: "Entrega fallida",
  21: "Recibido para devolución",
  22: "En bodega (devolución)",
  31: "En ruta (devolución)",
  41: "Devolución completada",
  100: "Etiqueta impresa",
};

export const packageStatusStyles = {
  0: "pending-style",
  1: "picked-style",
  2: "in-storage-style",
  3: "in-route-style",
  4: "delivered-style",
  5: "cancelled-style",
  6: "cancelled-style",
  7: "cancelled-style",
  21: "return-received-style",
  22: "return-warehouse-style",
  30: "in-route-style",
  31: "return-route-style",
  41: "returned-style",
  100: "in-storage-style",
};

export const packageStatusEvidenceStyles = {
  0: "pending-style-evidence",
  1: "picked-style-evidence",
  2: "in-storage-style-evidence",
  3: "in-route-style-evidence",
  4: "delivered-style-evidence",
  5: "cancelled-style-evidence",
  6: "cancelled-style-evidence",
  7: "cancelled-style-evidence",
  21: "return-received-style-evidence",
  22: "return-warehouse-style-evidence",
  30: "in-route-style-evidence",
  31: "return-route-style-evidence",
  41: "returned-style-evidence",
  100: "in-storage-style-evidence",
};

// Alineado con getPackageStatusByMeliStatus (microservice-packages cron)
export const meliStatusLabels = {
  0: "Pendiente",
  1: "Recolectado",
  2: "En bodega",
  3: "En Ruta",
  4: "Entregado",
  5: "Cancelado",
  6: "Fallido",
};

export const meliStatusClass = {
  0: "meli-badge--pending",
  1: "meli-badge--picked",
  2: "meli-badge--warehouse",
  3: "meli-badge--route",
  4: "meli-badge--delivered",
  5: "meli-badge--cancelled",
  6: "meli-badge--failed",
};

// Orden lógico para el filtro: flujo normal 0→1→2→3→30→4, luego fallos 5,6,7 y devoluciones 21→22→31→41
const FILTER_STATUS_ORDER = [0, 1, 2, 3, 30, 4, 5, 6, 7, 21, 22, 31, 41];

export const packageStatusFilterOptions = FILTER_STATUS_ORDER.map((value) => ({
  value,
  label: packageStatus[value],
}));
